import { $el, $elParent } from 'src/scripts/utils/utils'
import { BaseComponent } from '../base-component'
import { CarouselComponent } from '../carousel/carousel'

const POSTER_SELECTOR = '[id^="Deferred-Poster-"]'
const CAROUSEL_SELECTOR = 'carousel-component'
const SLIDE_ATTRIBUTE = '[data-media-id]'
const AUTOPLAY_ATTRIBUTE = 'data-autoplay'

export class DeferredMedia extends BaseComponent {
  carousel: CarouselComponent
  video: HTMLVideoElement

  mountComponent(): void {
    this.carousel = $elParent(CAROUSEL_SELECTOR, this)

    if (this.hasAttribute(AUTOPLAY_ATTRIBUTE)) {
      this.loadContent()
      this.carousel?.embla.on('select', this.handleCarouselSelect)
    } else {
      this.addListener(this, 'click', this.handlePosterClick)
    }
  }

  unmountComponent(): void {
    this.carousel?.embla.off('select', this.handleCarouselSelect)
  }

  handleCarouselSelect = (): void => {
    this.togglePlayVideo()
  }

  togglePlayVideo = () => {
    const slide = $elParent(SLIDE_ATTRIBUTE, this)
    const isSelected = slide.className.includes('is-selected')

    if (isSelected && this.video.paused) {
      this.video.play()
    } else {
      this.video.pause()
    }
  }

  handlePosterClick = (event: MouseEvent): void => {
    const poster = $elParent(POSTER_SELECTOR, event.target)

    if (poster) {
      this.loadContent()
    }
  }

  loadContent(): void {
    if (!this.getAttribute('loaded')) {
      this.addVideo()
      this.setAttribute('loaded', 'true')
    }
  }

  removeVideo(): void {
    const video = $el('video,  iframe', this)

    if (video) {
      video.remove()
      this.removeAttribute('loaded')
    }
  }

  addVideo(): void {
    const content = document.createElement('div')
    const template: HTMLTemplateElement = $el('template', this)
    const templateContent = template?.content

    if (!templateContent || !templateContent.firstElementChild) {
      return
    }

    const firstChild = templateContent.firstElementChild.cloneNode(true)

    content.appendChild(firstChild)
    const video: HTMLVideoElement = $el('video, model-viewer, iframe', content)

    if (!video) {
      return
    }

    this.appendChild(video)

    this.video = video

    if (video.tagName === 'VIDEO') {
      this.togglePlayVideo()
    }
  }
}
